/**
 * Icing model
 */
export class IcingModel {

    minAlt: string;

    maxAlt: string;

    intensity: string;

    /**
     * Parses icing from API
     * @param minAlt string
     * @param maxAlt string
     * @param intensity string
     * @returns {IcingModel} icing layer
     */
    static parse(minAlt, maxAlt, intensity): IcingModel {
        return {
            minAlt,
            maxAlt,
            intensity
        };
    }
}
